module["exports"] = [
  "4###########L",
  "4###-####-####-###L"
];
